/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Like } from "./like.entity";
import { BasePlateSnapshot } from "./plate.entity";

export interface UserSnapshot {
  id: string;
  username: string;
  displayName?: string;
  avatarUrl?: string;
  bio?: string;
  email: string;
  badges: string;
  registeredWithUrbit: boolean;
  inviteId?: string;
  emailVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
  passwordHash?: string;
  generatedKey: boolean;
  verifiedKey: boolean;
  overloadInviteId?: string;
  confirmCode?: string;
  notificationsClearedAt?: Date;
  sharedPagesClearedAt?: Date;
  feedClearedAt?: Date;
  settings: UserSettings;
  remainingInvites: number;
  isGoodFollow: boolean;
  onboardingComplete: boolean;
  followers: PublicUser[];
  following: PublicUser[];
  pages?: BasePlateSnapshot[];
  likes?: Like[];
}

export type TutorialStatus = "not-started" | "started" | "ready-to-complete" | "completed" | "skipped";

// the settings object on the user
export interface UserSettings {
  tutorial: { status: TutorialStatus; currentStep: string };
}

export enum PublicUserProperties {
  id = "id",
  username = "username",
  createdAt = "createdAt",
  avatarUrl = "avatarUrl",
  displayName = "displayName",
  bio = "bio",
  badges = "badges",
  registeredWithUrbit = "registeredWithUrbit",
  generatedKey = "generatedKey", // TODO rm
  verifiedKey = "verifiedKey", // TODO rm
  inviteId = "inviteId",
}

export type PublicUser = Pick<UserSnapshot, PublicUserProperties>;
export type PublicUserWithFollows = PublicUser & { followers: PublicUser[]; following: PublicUser[] };
